import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=752fd3c7"
import script from "./Detail.ts?vue&type=script&lang=ts&external"
export * from "./Detail.ts?vue&type=script&lang=ts&external"
import style0 from "./Detail.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports